import { cycleCountRuleIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getCycleCountRule = unaryRpc({
  name: "getCycleCountRule" as const,
  input: z.object({ id: cycleCountRuleIdFormat.schema }),
  output: z.object({
    id: cycleCountRuleIdFormat.schema,
    name: z.string(),
    description: z.string().nullable(),
    type: z.literal("abc"),
    status: z.enum(["live", "disabled", "draft"]),
    data: z.unknown(),
    dueDaysAfterCreation: z.int(),
    createdAt: z.date(),
    updatedAt: z.date(),
  }),
});
